/**
 * 英文版
 */

export const lang = {
  // 头部
  header: {
    title: 'Title of the platform',
    projectTypes: 'Project Types',
    projectName: 'Items',
    addProject: 'New Project',
    entryProject: 'Enter',
    backHome: 'Back to the front',
    warnNums: 'Warning Number',
    warnProjects: 'Warning Projects nums',
    modifyUserInformation: 'Modify User information',
    changePassword: 'Change Password',
    userManagement: 'User management',
    agingTest: 'Aging Test',
    forcedDelete: 'Forced deactivation',
    propertSettings: 'Property settings',
    infraredAgingTest: 'Infrared Aging Test',
    authorizationManagement: 'Authorization Management',
    logout: 'Logout',
    changeNickname: 'Modify user information',
    oldPassword: 'Old Password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    alarmList: 'List of warning device',
    viewAlarmContent: 'View warning content',
    alarmContent: 'Warning Content',
    processingEquipment: 'Processing device',
    noAlarmData: 'No Warning Data',
    alarmProjectList: 'List of warning project',
    doubleClickView: 'Double click to view the Warning device',
    password: 'Password',
    newProject: 'New project',
    voucherCenter: 'Voucher Center',
    autoLocation: 'auto position',
    positionType: 'position type'
  },
  // 通用
  common: {
    welcome: 'Welcome',
    accountLogin: 'Account login',
    login: 'Login',
    account: 'Account',
    cancel: 'Cancel',
    sure: 'Ok',
    name: 'Name',
    snName: 'SN number',
    pnName: 'PN number',
    submit: 'Submit',
    add: 'add',
    username: 'User name',
    roleName: 'Role name',
    nickname: 'Nickname',
    operate: 'Operate',
    edit: 'Edit',
    delete: 'Delete',
    searchDeviceName: 'Search device name',
    deviceName: 'Device name',
    state: 'State',
    updateTime: 'Update time',
    expiresTime: 'Expire time',
    lng: 'Longitude',
    lat: 'Latitude',
    owner: 'OWNER',
    manager: 'MANAGER',
    member: 'MEMBER',
    guest: 'GUEST',
    proprietor: 'PROPRIETOR OWNER',
    selectDate: 'Select Date',
    startDate: 'Start date',
    endDate: 'End date',
    startTime: 'Start time',
    endTime: 'End time',
    createTime: 'Create time',
    loading: 'Loading...',
    comfirmLogout: 'Confirm log out?',
    setNoAlarm: 'Confirm that the device is set to no warning?',
    brightness: 'Dimming',
    switch: 'Switch',
    sunrise: 'Sunrise',
    sunset: 'Sunset',
    remark: 'Comment',
    all: 'All',
    choose: 'Please choose',
    currentGroup: 'Group',
    noDevices: 'no devices',
    gotoAdd: 'Go to add',
    cruuentDevicesNumber: 'Current running devices',
    showOfflineList: 'View offline list',
    showPowerDowmList: 'View power down list',
    showLightOutList: 'View off list',
    online: 'On-line',
    offline: 'Off-line',
    alarm: 'Warning',
    lighting: 'Lighting',
    dowmLight: 'Turn off',
    Electrify: 'Electrify',
    powerFailure: 'Power failure',
    solarPanels: 'Solar panels',
    battery: 'Battery',
    deviceStatus: 'last time update the status',
    update: 'Update',
    power: 'Power',
    voltage: 'Voltage',
    current: 'Current',
    offlineList: 'Offline device list',
    lightOutList: 'Off device list',
    powerOffList: 'List of power-off device',
    issuingInstruction: 'Issuing instructions...',
    open: 'On',
    close: 'Off',
    dimming: 'Dimming',
    charge: 'Charge',
    network: 'Network',
    connectionMode: 'Communication mode',
    signalIntensity: 'Signal level',
    batteryStatus: 'Battery status',
    switchStatus: 'Switching state',
    solar: 'Solar panel',
    solarVoltage: 'Solar panel voltage',
    solarCurrent: 'Solar panel current',
    batteryVoltage: 'Battery voltage',
    batteryCurrent: 'Battery current',
    activeTime: 'Active Time',
    check: 'Check',
    updateState: 'Update state',
    bodyResponse: 'Motion sense detector',
    hybridSolarPowered: 'Hybrid solar powered',
    switchController: 'Powerline switch controller',
    deviceParamsInfo: 'Device parameter information',
    command: 'Command',
    infraredStatus: 'Infrared status',
    strategyStatus: 'Strategy status',
    parameterStatus: 'Parameter',
    details: 'Details',
    more: 'More',
    currentStrategy: 'Current strategy',
    batteryType: 'Battery type',
    LiFePO4: 'LiFePO4',
    ternaryLithium: 'Ternary Lithium',
    leadAcid: 'Lead-Acid',
    sodiumIon: 'sodium-ion',
    colloid: 'Colloid',
    liquid: 'Liquid',
    ratedCurrent: 'Rated current',
    batteryVoltageMultiplier: 'Battery voltage multiplier',
    strongChargeVoltage: 'Strong charging voltage',
    evenChargeVoltage: 'Even charging voltage',
    floatChargeVoltage: 'Floating charge voltage',
    overVoltage: 'Over-voltage',
    overToBackVoltage: 'Over-voltage recovery',
    lowVoltage: 'Under-voltage',
    lowToBackVoltage: 'Under-voltage recovery',
    dayThreshold: 'Threshold voltage value(dawn)',
    nightThreshold: 'Threshold voltage value(night)',
    chargeCapacity: 'Charging',
    dischargeCapacity: 'Discharging',
    remainCapacity: 'Remaining capacity',
    other: 'Other',
    temperatures: 'Environmental temperature',
    voltageType: 'Voltage type',
    singleBattery: 'Single battery',
    constantCurrent: 'Constant Current LED controller',
    hybridConstant: 'Hybrid solar powered constant current LED controller',
    hybridSwitch: 'Hybrid solar powered switch controller',
    solar4g: 'solar powered 4g gateway',
    customizedController: 'Customized controller',
    pvSolarController: 'pv solar controller',
    allUsers: 'All users',
    PARTNER: 'PARTNER',
    CUSTOMER: 'CUSTOMER',
    ENDUSER: 'ENDUSER',
    SALE: 'SALE',
    DEALER: 'DEALER',
    ENTERPRISE_ADMIN: 'ENTERPRISE_ADMIN',
    ENTERPRISE_SALE: 'ENTERPRISE_SALE',
    ENTERPRISE_CUSTOMER_L1: 'ENTERPRISE_CUSTOMER_L1',
    ENTERPRISE_CUSTOMER_L2: 'ENTERPRISE_CUSTOMER_L2',
    ENTERPRISE_CUSTOMER_L3: 'ENTERPRISE_CUSTOMER_L3',
    PROPRIETOR: 'PROPRIETOR',
    creater: 'Creater',
    systemName: 'System name',
    unlock: 'Unlock',
    lock: 'Lock',
    resetPassword: 'Reset password',
    subsystem: 'Subsystem',
    addUser: 'New users',
    powerSupply: 'Power supply',
    dimmingMode: 'Dimming mode',
    signalValue: 'Signal value',
    weakest: 'Weakest',
    weak: 'Weak',
    general: 'General',
    stronger: 'Stronger',
    strong: 'Strong'
  },
  // 消息提示
  prompt: {
    passwordAgain: 'Please enter the password again',
    disaccord: 'The two passwords are inconsistent',
    inputNickname: 'Please enter a nickname',
    inputNewPassword: 'Please enter a new password',
    maxLength5: 'Length cannot be greater than 5 characters',
    maxLength16: 'Length cannot be greater than 32 characters',
    snLength8: 'The SN number is 8 bits',
    inputOldPassword: 'Please enter the old password',
    minLengthPassword: 'Password minimum 6 digits',
    correctLngLat: 'Please enter the correct longitude value',
    inputDeviceName: 'Please enter the device name',
    noEmpty: 'Can not be empty',
    success: 'Success',
    warning: 'Warning',
    error: 'Error',
    saveSuccess: 'Save successfully',
    deleteSuccess: 'Delete successfully',
    noMatching: 'No matching role name',
    tips: 'Tips',
    isDeleteUser: 'Are you sure to delete this user?',
    cancelled: 'Cancelled',
    affectDisplay: 'This operation will affect the display device in the device center. Do you want to continue?',
    selectDevice: 'Please select the device to operate',
    noSetEnable: 'The device in use cannot be set to enabled',
    disableNoDisable: 'Disabled device cannot be set to disabled',
    failedDevices: 'The failed devices are:',
    isDeleteDevice: 'This operation will delete the device. Do you want to continue?',
    useNoDelete: 'The device in use cannot be deleted',
    only4tags: 'Only 4 labels can be set at most',
    exist: 'Already exist',
    followSuccess: 'Focus on success',
    noFollowSuccess: 'Cancellation of attention succeeded',
    selectItem: 'Please select an item',
    isDeleteStrategy: 'This operation will permanently delete the policy. Do you want to continue?',
    anyTime: 'Any time',
    inputNumber: 'Please enter a numeric value',
    brightnessRange: 'Brightness range 0 ~ 100',
    max6Periods: 'Up to 6 time periods',
    isOpenIntelligentPower: 'Turn on the intelligent power, it will automatically multiply the current brightness by the appropriate percentage according to the battery condition, and then issue. Do you want to continue to turn on?',
    isDeleteGroup: 'This operation will permanently delete the group. Do you want to continue?',
    selectGroup: 'Please select group',
    comfirmMove: 'Are you sure you want to move the device to this group?',
    fail: 'Fail',
    isGroupOpen: 'This operation will send open command to devices in this group. Do you want to continue?',
    isGroupClose: 'This operation will send a shutdown command to the devices in this group. Do you want to continue?',
    isGroupCharge: 'This operation will send charging instructions to the devices in the group. Do you want to continue?',
    isGroupPowerFailure: 'This operation will send a power-off command to the devices in the group. Do you want to continue?',
    isOpen: 'This operation will send a open command. Do you want to continue?',
    isClose: 'This operation will send a close command. Do you want to continue?',
    brightnessNotEmpty: 'Brightness cannot be empty',
    supplyVoltageRange: 'The power supply voltage should be between 9 and 30!',
    rangeBetween: 'The value should be between',
    snFirst: 'Please enter Sn first',
    snErrorRules: 'Sn number does not conform to the rules',
    noRatedCurrent: 'Rated current cannot be empty',
    checkSuccess: 'Check succeeded, please upload the document to the bottom again',
    locationNoEmpty: 'Please select the location of the project',
    alarmSolarPanel: 'Abnormal solar panel',
    overvoltage: 'Overvoltage protection',
    overCurrent: 'Over current protection',
    overUnderTemperature: 'Over / under temperature protection',
    lowVoltage: 'Battery low voltage protection',
    highVoltage: 'Battery high voltage protection',
    shortCircuit: 'Short circuit protection',
    hardware: 'Hardware protection',
    errorCode: 'General error code',
    userNameLength: 'User name length 3-16 bits',
    nickNameLength: 'Nickname length 2-10 digits',
    electricalNoEmpty: 'Electric equipment cannot be empty',
    itemNameNoEmpty: 'Item name cannot be empty',
    timeLimit: 'Start time cannot be greater than end time',
    timeRange: 'Date range cannot exceed 3 days',
    switchLanguageSuccess: 'Switch language successfully',
    timeRange14: 'The time range can only be within 14 days',
    timeRange3Month: 'The time range can only be within 3 months',
    changeLocation: 'The selected device location will be changed. Do you want to continue?',
    inputPositive: 'Please enter a positive integer'
  },
  // 导航菜单
  navbar: {
    equipmentCenter: 'Device Center',
    monitoringCenter: 'Monitoring Center',
    alarmCenter: 'Warning Center',
    strategyCenter: 'Strategy Center',
    groupManagemen: 'Group managemen',
    projectInformation: 'Project information'
  },
  // 项目信息
  projectInfo: {
    scanningLocation: 'Scanning location',
    concerned: 'Concerned',
    notConcerned: 'not concerned',
    electricalEquipment: 'Electrical device',
    owner: 'Owner',
    identity: 'Identity',
    projectLocation: 'Project location',
    tag: 'Tag',
    maxLength7: 'Length cannot be greater than 7 characters',
    projectPeople: 'mber of people',
    addTags: 'Add tags',
    management: 'Management',
    equipmentQuantity: 'Quantity of device',
    searchName: 'Search user name',
    addProjectUsers: 'Add project users',
    editProjectUsers: 'Edit project users',
    managementEquipment: 'Management device',
    batchIncrease: 'Batch increase',
    batchDelete: 'Batch delete',
    enable: 'Enable',
    disable: 'disable',
    downloadTemplate: 'Download template',
    modifyParameters: 'modify parameters',
    editDeviceInfo: 'Edit device information',
    authenticate: 'Authenticate users',
    addDevice: 'add device',
    checkExcel: 'Check Excel',
    DragFiles: 'Drag files here, or',
    clickUpload: 'Click upload',
    uploadExcel: 'Upload Excel',
    noRolename: 'No matching role name'
  },
  // 告警
  warn: {
    alarmState: 'Warning state',
    alreadyRead: 'Already read',
    untreated: 'Untreated',
    alarmType: 'Warning yype',
    alarmLevel: 'Warning level',
    processingState: 'Processing state',
    alarmTime: 'Warning time',
    alarmContent: 'Warning content',
    solutionReference: 'reference',
    today: 'Today',
    yesterday: 'Yesterday',
    aWeekAgo: 'A week ago',
    threeDayAgo: 'Three days ago',
    checkSolar: 'Please check whether the solar wiring is correct and whether the solar panel is blocked',
    checkDevice: 'Check whether the wires of electric equipment are correct and whether the serial and parallel numbers of electric equipment are reasonable',
    overCurrentProtection: 'Overcurrent protection of electric equipment',
    checkCharge: 'The battery is low, please confirm whether the charging is normal',
    checkWiring: 'Check whether the battery wiring is correct'
  },
  // 策略
  strategy: {
    strategyList: 'Strategy list',
    newStrategy: 'New strategy',
    strategyName: 'Strategy name',
    intelligentPower: 'Intelligent power',
    turnOnPower: 'Turn on smart power',
    lightControl: 'Photocontrol',
    weatherControl: 'weather control',
    turnOnLight: 'Turn on photocontrol',
    copyAdded: 'Add and rename',
    strategyInformation: 'Strategy information',
    stage: 'Stage',
    addState: 'Add time stage',
    time: 'Time',
    tagAttribute: 'Tag attribute',
    setReduceRatio: 'Setting the power reduction ratio'
  },
  // 监控
  monitor: {
    dataStatistics: 'Data detail',
    historyData: 'Historical data statistics',
    historyChargeData: 'Historical charge and discharge',
    historyPower: 'Historical power on time',
    historyLightingTime: 'History lighting duration',
    monthWeather: 'Monthly weather statistics'
  },
  // 分组
  group: {
    groupList: 'Group list',
    noGroup: 'Ungrouped',
    editGroup: 'Edit group',
    createGroup: 'Please create a new group',
    viewStrategy: 'View strategy',
    setStrategy: 'Issuing strategy',
    moveTo: 'Move to',
    filterGruop: 'Filter group',
    moveToGroup: 'Please move the device to the group',
    addDevice: 'Please add device',
    groupName: 'Group name',
    addGroup: 'Add group',
    selectStrategy: 'Please select a policy',
    strategyToGroup: 'Are you sure you want to distribute the strategy to this group?',
    groupNoStrategy: 'There is no applied strategy for this group',
    noData: 'No data'
  },
  // 设备中心
  device: {
    toWarn: 'Go to the Warning center',
    overView: 'Device overview',
    toList: 'Switch to list mode',
    toMap: 'Switch to map mode',
    icon: 'Icon',
    waitRenderMap: 'If there are a large number of devices in the same latitude and longitude, it may cause slow map rendering, please wait patiently',
    changeCoordinates: 'Change coordinates',
    updateFaile: 'Update failed, device last updated at',
    updateAgain: 'Update again?',
    changeMapLocation: 'Drag the device in the map to change the location!',
    noResponse: 'No response from device',
    ledInfo: 'Voltage / current / power',
    solarInfo: 'Solar panel voltage / current / power',
    batteryInfo: 'Batter panel voltage / current / power',
    openHumanFlow: 'Open human flow control',
    closeHumanFlow: 'Turn off human flow control',
    setPowerSupply: 'Switching power supply voltage',
    setIntelligentPower: 'Intelligent power settings',
    setZeroCharge: 'Zero degree charging mode',
    chargeMode: 'Charging mode',
    faileDevices: 'Update failed device',
    baseInfo: 'Basic information',
    operationRecord: 'Operation record',
    paramsTime: 'Parameter distribution time',
    strategyIssueStatus: 'Strategy issue status',
    isSettedParam: 'Parameter issue status',
    notIssued: 'Not issued',
    alreadyIssued: 'Already issued',
    currentGainTime: 'Current acquisition time',
    intelligenceStrategy: 'Intelligence strategy',
    strategyTime: 'Strategy issue time',
    tiemPeriod: 'Time Period',
    at: 'at'
  },
  // 充值中心
  voucher: {
    voucherCenter: 'Voucher Center',
    commodity: 'Commodity',
    order: 'Order',
    setting: 'Setting',
    backHome: 'BackHome',
    allStatus: 'All Status',
    completed: 'Completed',
    paid: 'Paid',
    refunding: 'Refunding',
    refunded: 'Refunded',
    refundFailed: 'Refund Failed',
    paymentFailure: 'Rayment Failure',
    waittingPayment: 'Waitting Payment',
    searchOrderId: 'SearchOrderId',
    orderId: 'OrderId:',
    noOrder: 'There is no order',
    information: 'commodity',
    price: 'price(¥)',
    rechargeCount: 'quantity(pieces)',
    payAmount: 'payAmount',
    buyer: 'buyer',
    payTime: 'payTime',
    orderStatus: 'status',
    operation: 'operation',
    deviceList: 'DeviceList',
    export: 'exportExcel',
    rechargeCompleted: 'rechargeCompleted',
    completionTime: 'CompletionTime:',
    deviceName: 'deviceName',
    sn: 'SN',
    sim: 'SIM',
    rechargeStatus: 'Recharge Status',
    rechargeSucceeded: 'Recharge Succeeded',
    charging: 'Charging',
    rechargeFailed: 'Recharge Failed',
    cancelled: 'Cancelled',
    confirmation: 'Recharge Confirmed',
    comfirmContent: 'Are you sure the order has been recharged?',
    comfirmTips: 'This operation cannot be changed, please be careful!',
    comfirmRefund: 'Are you sure you want to refund the order?',
    refund: 'refund',
    handlingMethod: 'handlingMethod',
    processingResults: 'processingResults',
    completeRefund: 'Completed Refund',
    cancelRefund: 'Cancel Refund',
    name: 'commodity',
    type: 'type',
    state: 'state',
    addCommodity: 'addCommodity',
    editCommodity: 'EditCommodity',
    edit: 'edit',
    itemDownshelf: 'itemDownshelf',
    ItemUpshelf: 'ItemUpshelf',
    tips: 'tips',
    itemDownshelfTips: 'This operation will remove the goods, do you want to continue?',
    itemUpshelfTips: 'This operation will be launched. Do you want to continue?',
    dellteTips: 'This operation will permanently delete the item. Do you want to continue?',
    namePlaceholder: 'Please enter the product name',
    monthlyFlow: 'Monthly flow',
    flow: 'Flow',
    flowMonth: 'flowMonth',
    sixMonths: '6 Months',
    twelveMonths: '12 Months',
    twentyFourMonths: '24 Months',
    priceNoUnit: 'price',
    unit: '¥',
    submit: 'submit',
    operationSuccess: 'Operation Success',
    operationCancelled: 'Operation Cancelled',
    itemDownshelfSuccess: 'ItemDownshelf Success',
    itemDownshelfCancelled: 'ItemDownshelf Cancelled',
    itemUpshelfSuccess: 'ItemUpshelf Success',
    itemUpshelfCancelled: 'ItemUpshelf Cancelled',
    deleteSuccess: 'Delete Success',
    deleteCancelled: 'Delete Cancelled',
    addSuccess: 'Add Success',
    addFailure: 'Add Failure',
    updateSuccess: 'Update Success',
    updateFailed: 'Update Failed'
  },
  // 验证规则
  rules: {
    selectRechargeType: 'Please select recharge type',
    enterProductName: 'Please enter the product name',
    enterPackageDuration: 'Please enter the package duration',
    cannotEmpty: 'Value cannot be empty',
    enterNumericValue: 'Please enter a numeric value',
    enterValueGreaterZero: 'Please enter a value greater than 0'
  }
}
